import type { FieldValues, Path, UseFormSetError } from 'react-hook-form';
import { ApiError } from '../../api/client';

/**
 * Puts a validation error's `details` (paths like `body.code`) next to the matching form fields.
 * Returns true when at least one field got a message (shared by the A3 forms: plans, admins).
 */
export function applyFieldErrors<T extends FieldValues>(
  error: unknown,
  setError: UseFormSetError<T>,
  fields: readonly Path<T>[],
): boolean {
  if (!(error instanceof ApiError)) return false;
  let applied = false;
  for (const d of error.details) {
    const name = d.path.replace(/^body\./, '').split('.')[0] as Path<T>;
    if (fields.includes(name)) {
      setError(name, { type: 'server', message: d.message });
      applied = true;
    }
  }
  return applied;
}

export function errorCode(error: unknown): string | undefined {
  return error instanceof ApiError ? error.code : undefined;
}
